import { render, staticRenderFns } from "./OverallRatingChart.vue?vue&type=template&id=1d4c1fa0&scoped=true"
import script from "./OverallRatingChart.vue?vue&type=script&lang=js"
export * from "./OverallRatingChart.vue?vue&type=script&lang=js"
import style0 from "./OverallRatingChart.vue?vue&type=style&index=0&id=1d4c1fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c1fa0",
  null
  
)

export default component.exports